/**
 * Preloaded rdfs:label definitions for common RDF, RDFS, OWL, XSD, and SHACL terms.
 * These labels improve the form's display of standard vocabulary terms.
 *
 * To update: edit this constant directly. It is loaded into the shapes store
 * before user-defined shapes when `preloadLabelsTtl` is enabled.
 */
export const PRELOAD_LABELS_TTL = `
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .
@prefix sh: <http://www.w3.org/ns/shacl#> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .
@prefix dcterms: <http://purl.org/dc/terms/> .

# ===== RDF =====
rdf:type rdfs:label "type" .
rdf:Property rdfs:label "Property" .
rdf:first rdfs:label "first" .
rdf:object rdfs:label "object" .
rdf:predicate rdfs:label "predicate" .
rdf:rest rdfs:label "rest" .
rdf:subject rdfs:label "subject" .
rdf:value rdfs:label "value" .
rdf:langString rdfs:label "langString" .
rdf:HTML rdfs:label "HTML" .
rdf:XMLLiteral rdfs:label "XMLLiteral" .
rdf:JSON rdfs:label "JSON" .

# ===== RDFS =====
rdfs:Class rdfs:label "Class" .
rdfs:Datatype rdfs:label "Datatype" .
rdfs:Literal rdfs:label "Literal" .
rdfs:Resource rdfs:label "Resource" .
rdfs:Container rdfs:label "Container" .
rdfs:ContainerMembershipProperty rdfs:label "ContainerMembershipProperty" .
rdfs:comment rdfs:label "comment" .
rdfs:domain rdfs:label "domain" .
rdfs:isDefinedBy rdfs:label "isDefinedBy" .
rdfs:label rdfs:label "label" .
rdfs:member rdfs:label "member" .
rdfs:range rdfs:label "range" .
rdfs:seeAlso rdfs:label "seeAlso" .
rdfs:subClassOf rdfs:label "subClassOf" .
rdfs:subPropertyOf rdfs:label "subPropertyOf" .

# ===== XSD Primitive Types =====
xsd:string rdfs:label "string" .
xsd:boolean rdfs:label "boolean" .
xsd:decimal rdfs:label "decimal" .
xsd:float rdfs:label "float" .
xsd:double rdfs:label "double" .
xsd:integer rdfs:label "integer" .
xsd:long rdfs:label "long" .
xsd:int rdfs:label "int" .
xsd:short rdfs:label "short" .
xsd:byte rdfs:label "byte" .
xsd:unsignedLong rdfs:label "unsignedLong" .
xsd:unsignedInt rdfs:label "unsignedInt" .
xsd:unsignedShort rdfs:label "unsignedShort" .
xsd:unsignedByte rdfs:label "unsignedByte" .
xsd:positiveInteger rdfs:label "positiveInteger" .
xsd:nonPositiveInteger rdfs:label "nonPositiveInteger" .
xsd:negativeInteger rdfs:label "negativeInteger" .
xsd:nonNegativeInteger rdfs:label "nonNegativeInteger" .

# ===== XSD Date/Time Types =====
xsd:date rdfs:label "date" .
xsd:time rdfs:label "time" .
xsd:dateTime rdfs:label "dateTime" .
xsd:dateTimeStamp rdfs:label "dateTimeStamp" .
xsd:duration rdfs:label "duration" .
xsd:dayTimeDuration rdfs:label "dayTimeDuration" .
xsd:yearMonthDuration rdfs:label "yearMonthDuration" .
xsd:gYear rdfs:label "gYear" .
xsd:gMonth rdfs:label "gMonth" .
xsd:gDay rdfs:label "gDay" .
xsd:gYearMonth rdfs:label "gYearMonth" .
xsd:gMonthDay rdfs:label "gMonthDay" .

# ===== XSD String/URI Types =====
xsd:anyURI rdfs:label "anyURI" .
xsd:normalizedString rdfs:label "normalizedString" .
xsd:token rdfs:label "token" .
xsd:language rdfs:label "language" .
xsd:Name rdfs:label "Name" .
xsd:NCName rdfs:label "NCName" .
xsd:NMTOKEN rdfs:label "NMTOKEN" .
xsd:QName rdfs:label "QName" .

# ===== XSD Binary/Other Types =====
xsd:hexBinary rdfs:label "hexBinary" .
xsd:base64Binary rdfs:label "base64Binary" .

# ===== OWL Classes =====
owl:Class rdfs:label "OWL Class" .
owl:AnnotationProperty rdfs:label "AnnotationProperty" .
owl:DatatypeProperty rdfs:label "DatatypeProperty" .
owl:ObjectProperty rdfs:label "ObjectProperty" .
owl:FunctionalProperty rdfs:label "FunctionalProperty" .
owl:InverseFunctionalProperty rdfs:label "InverseFunctionalProperty" .
owl:SymmetricProperty rdfs:label "SymmetricProperty" .
owl:TransitiveProperty rdfs:label "TransitiveProperty" .
owl:Restriction rdfs:label "Restriction" .
owl:Thing rdfs:label "Thing" .
owl:Nothing rdfs:label "Nothing" .
owl:NamedIndividual rdfs:label "NamedIndividual" .
owl:Ontology rdfs:label "Ontology" .

# ===== OWL Properties =====
owl:allValuesFrom rdfs:label "allValuesFrom" .
owl:cardinality rdfs:label "cardinality" .
owl:disjointWith rdfs:label "disjointWith" .
owl:equivalentClass rdfs:label "equivalentClass" .
owl:equivalentProperty rdfs:label "equivalentProperty" .
owl:hasValue rdfs:label "hasValue" .
owl:intersectionOf rdfs:label "intersectionOf" .
owl:inverseOf rdfs:label "inverseOf" .
owl:maxCardinality rdfs:label "maxCardinality" .
owl:minCardinality rdfs:label "minCardinality" .
owl:onProperty rdfs:label "onProperty" .
owl:someValuesFrom rdfs:label "someValuesFrom" .
owl:unionOf rdfs:label "unionOf" .
owl:imports rdfs:label "imports" .
owl:versionInfo rdfs:label "versionInfo" .
owl:sameAs rdfs:label "sameAs" .
owl:differentFrom rdfs:label "differentFrom" .
owl:maxQualifiedCardinality rdfs:label "maxQualifiedCardinality" .
owl:minQualifiedCardinality rdfs:label "minQualifiedCardinality" .
owl:qualifiedCardinality rdfs:label "qualifiedCardinality" .
owl:onClass rdfs:label "onClass" .
owl:onDataRange rdfs:label "onDataRange" .
owl:oneOf rdfs:label "oneOf" .
owl:complementOf rdfs:label "complementOf" .
owl:distinctMembers rdfs:label "distinctMembers" .
owl:members rdfs:label "members" .

# ===== SHACL Core =====
sh:NodeShape rdfs:label "NodeShape" .
sh:PropertyShape rdfs:label "PropertyShape" .
sh:Shape rdfs:label "Shape" .

# ===== SHACL Target =====
sh:targetClass rdfs:label "targetClass" .
sh:targetNode rdfs:label "targetNode" .
sh:targetObjectsOf rdfs:label "targetObjectsOf" .
sh:targetSubjectsOf rdfs:label "targetSubjectsOf" .

# ===== SHACL Property Constraints =====
sh:path rdfs:label "path" .
sh:property rdfs:label "property" .
sh:class rdfs:label "class" .
sh:datatype rdfs:label "datatype" .
sh:nodeKind rdfs:label "nodeKind" .
sh:minCount rdfs:label "minCount" .
sh:maxCount rdfs:label "maxCount" .
sh:minLength rdfs:label "minLength" .
sh:maxLength rdfs:label "maxLength" .
sh:minExclusive rdfs:label "minExclusive" .
sh:maxExclusive rdfs:label "maxExclusive" .
sh:minInclusive rdfs:label "minInclusive" .
sh:maxInclusive rdfs:label "maxInclusive" .
sh:pattern rdfs:label "pattern" .
sh:flags rdfs:label "flags" .
sh:in rdfs:label "in" .
sh:hasValue rdfs:label "hasValue" .
sh:equals rdfs:label "equals" .
sh:disjoint rdfs:label "disjoint" .
sh:lessThan rdfs:label "lessThan" .
sh:lessThanOrEquals rdfs:label "lessThanOrEquals" .
sh:uniqueLang rdfs:label "uniqueLang" .

# ===== SHACL Shape Properties =====
sh:name rdfs:label "name" .
sh:description rdfs:label "description" .
sh:order rdfs:label "order" .
sh:group rdfs:label "group" .
sh:defaultValue rdfs:label "defaultValue" .
sh:closed rdfs:label "closed" .
sh:ignoredProperties rdfs:label "ignoredProperties" .
sh:deactivated rdfs:label "deactivated" .
sh:message rdfs:label "message" .
sh:severity rdfs:label "severity" .
sh:node rdfs:label "node" .
sh:qualifiedValueShape rdfs:label "qualifiedValueShape" .
sh:qualifiedMinCount rdfs:label "qualifiedMinCount" .
sh:qualifiedMaxCount rdfs:label "qualifiedMaxCount" .

# ===== SHACL Logical Constraints =====
sh:and rdfs:label "and" .
sh:or rdfs:label "or" .
sh:not rdfs:label "not" .
sh:xone rdfs:label "xone" .

# ===== SHACL Node Kinds =====
sh:BlankNode rdfs:label "BlankNode" .
sh:IRI rdfs:label "IRI" .
sh:Literal rdfs:label "Literal" .
sh:BlankNodeOrIRI rdfs:label "BlankNodeOrIRI" .
sh:BlankNodeOrLiteral rdfs:label "BlankNodeOrLiteral" .
sh:IRIOrLiteral rdfs:label "IRIOrLiteral" .

# ===== SHACL Severity =====
sh:Violation rdfs:label "Violation" .
sh:Warning rdfs:label "Warning" .
sh:Info rdfs:label "Info" .

# ===== SKOS (commonly used) =====
skos:Concept rdfs:label "Concept" .
skos:ConceptScheme rdfs:label "ConceptScheme" .
skos:Collection rdfs:label "Collection" .
skos:prefLabel rdfs:label "prefLabel" .
skos:altLabel rdfs:label "altLabel" .
skos:hiddenLabel rdfs:label "hiddenLabel" .
skos:definition rdfs:label "definition" .
skos:note rdfs:label "note" .
skos:broader rdfs:label "broader" .
skos:narrower rdfs:label "narrower" .
skos:related rdfs:label "related" .
skos:inScheme rdfs:label "inScheme" .
skos:hasTopConcept rdfs:label "hasTopConcept" .
skos:topConceptOf rdfs:label "topConceptOf" .
skos:notation rdfs:label "notation" .
skos:example rdfs:label "example" .
skos:scopeNote rdfs:label "scopeNote" .
skos:historyNote rdfs:label "historyNote" .
skos:editorialNote rdfs:label "editorialNote" .
skos:changeNote rdfs:label "changeNote" .

# ===== Dublin Core Terms (commonly used) =====
dcterms:title rdfs:label "title" .
dcterms:description rdfs:label "description" .
dcterms:creator rdfs:label "creator" .
dcterms:created rdfs:label "created" .
dcterms:modified rdfs:label "modified" .
dcterms:date rdfs:label "date" .
dcterms:identifier rdfs:label "identifier" .
dcterms:subject rdfs:label "subject" .
dcterms:type rdfs:label "type" .
dcterms:format rdfs:label "format" .
dcterms:language rdfs:label "language" .
dcterms:source rdfs:label "source" .
dcterms:rights rdfs:label "rights" .
dcterms:license rdfs:label "license" .
dcterms:publisher rdfs:label "publisher" .
dcterms:contributor rdfs:label "contributor" .
dcterms:isPartOf rdfs:label "isPartOf" .
dcterms:hasPart rdfs:label "hasPart" .
dcterms:references rdfs:label "references" .
dcterms:spatial rdfs:label "spatial" .
dcterms:temporal rdfs:label "temporal" .
`